import React from "react";
import { StatusBadge } from "../StatusBadge";
import { formatJst } from "../../lib/date";

/** Every interview booking for this applicant, most recent first - including terminal ones
 * (CANCELLED_BY_*, RESCHEDULED, COMPLETED, NO_SHOW, EXPIRED) so the recruiter can see the full
 * history, not just the currently-active one. */
export const ApplicantInterviewHistory = ({ bookings }) => {
  if (!bookings || bookings.length === 0) {
    return <p className="text-xs text-gray-500" data-testid="applicant-no-interview-history">No interview has ever been requested for this applicant.</p>;
  }
  const sorted = [...bookings].sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""));
  return (
    <div className="space-y-2" data-testid="applicant-interview-history">
      {sorted.map((b) => (
        <div key={b.id} className="flex items-center justify-between gap-3 border border-gray-100 rounded-lg px-3 py-2" data-testid={`interview-history-row-${b.id}`}>
          <div className="text-sm text-gray-700">
            {b.interview_mode === "CONTACT_ME" ? (
              <span className="text-gray-500">Requested management contact instead of a slot</span>
            ) : (
              <>
                <span className="font-semibold">{b.date}</span> @ {b.start_time} JST
                {b.interviewer_name && <span className="text-xs text-gray-500 ml-1.5">with {b.interviewer_name}</span>}
              </>
            )}
            {b.cancelled_reason && <p className="text-xs text-gray-500 mt-0.5">Reason: {b.cancelled_reason}</p>}
          </div>
          <div className="flex flex-col items-end gap-0.5 shrink-0">
            <StatusBadge status={b.status} />
            <span className="text-[10px] text-gray-500">{formatJst(b.created_at)}</span>
          </div>
        </div>
      ))}
    </div>
  );
};
